import { render, staticRenderFns } from "./PreviewTicket.vue?vue&type=template&id=b61e6c3e&scoped=true"
import script from "./PreviewTicket.vue?vue&type=script&lang=js"
export * from "./PreviewTicket.vue?vue&type=script&lang=js"
import style0 from "./PreviewTicket.vue?vue&type=style&index=0&id=b61e6c3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b61e6c3e",
  null
  
)

export default component.exports